import { useSessionStore } from '@/store/session'
import { useProjectBaseStore } from '@/store/projectBase'

export const isLoggedIn = () => !!useSessionStore().getToken
export const getSessionInfo = () => useSessionStore().getAllCustomerInfo
export const addToRequestsList = (requestInfo) => useProjectBaseStore().addToRequestsList(requestInfo)
export const cancelAllPendingRequests = () => useProjectBaseStore().cancelAllPendingRequests()
export const saveRouteParams = (routeParams) => useProjectBaseStore().saveRouteParams(routeParams)
export const removeRouteParams = () => useProjectBaseStore().removeRouteParams()
export const getRouteParams = () => useProjectBaseStore().getRouteParams
export const getMobileAppState = () => useProjectBaseStore().getMobileAppState
export const hideTokenChallengeModal = () => useProjectBaseStore().hideTokenChallengeModal()
export const forceLogout = () => useSessionStore().forceLogout()
